import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import { Field } from "formik";
import NumberInput from "web/components/form-elements/NumberInput";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import Textarea from "web/components/form-elements/TextArea";
import DatePicker from "web/components/DatePicker";
import * as moment from "moment";
import { palletDetails } from "redux/actions/adminPtPlus";
import Spinner from 'web/components/Spinner'
import AlertModal from 'web/components/AlertModal';
import YesNoModal from "web/components/YesNoModal";
import { Modal, ModalBody } from 'reactstrap';
import { VendorPricingAddModal } from '../VendorPricingStyled'
import CloseIcon from "web/assets/images/CloseIcon.png";
import EditIcon from "web/assets/svg/PtPlusUserEditIcon";
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import RadioButton from 'web/components/form-elements/RadioButton';
import { ptPlusVendorPricingAddData, ptPlusVendorPricingAddMoreVendorData, ptPlusVendorPricingGetCustomerFee } from "redux/actions/adminPTPlusVendorPricing";
import { materialList, woodConditions, plasticConditions, hardOrSoftWoodArray, newOrRecycledPalletList, comboPalletList, vendorPricingAddTableHeader } from "../Constants"

function VendorPricingModal(props) {
  const { closeModal, vendorLocationList, setFieldValue, formikValues, errors, resetForm, pageType, addMoreSelectedItem } = props
  const token = localStorage.getItem("token")
  const dispatch = useDispatch();
  let history = useHistory();

  const [loader, setLoader] = useState(false)
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible)

  const [modalMode, setModalMode] = useState('add')
  const [updateIndex, setUpdateIndex] = useState()
  const [palletSpecificationDetails, setPalletSpecificationDetails] = useState()
  const [moistureList, setmoistureList] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [temporaryTableData, setTemporaryTableData] = useState([])

  const [alertModal, setAlertModal] = useState(false)
  const [alertModalContent, setAlertModalContent] = useState('')
  const [alertModalType, setAlertModalType] = useState()
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);

  useEffect(() => {
    fetchPalletSpecDetails();

    // this is just added, not used, to pass formik required fields validation(during add more vendors
    // we are using this same popup(because of similar operation) but these fields wont be needed here)
    if (pageType === 'addMoreVendor') {
      setFieldValue("customerName", addMoreSelectedItem.id);
      setFieldValue("mainLocationName", addMoreSelectedItem.customerLocationName);
      setFieldValue("customerLocationId", addMoreSelectedItem.customerLocationId);
    }
  }, []);

  const fetchPalletSpecDetails = async () => {
    let response = await dispatch(palletDetails());
    if (response.success) {
      setPalletSpecificationDetails(response.data);
    } else setPalletSpecificationDetails();
  };

  const clearFields = (...fields) => {
    fields.forEach(field => setFieldValue(field, ""));
  }

  const hardOrSoftWoodDiv = () => {
    return (
      <div className="hardSoftWood-styles">
        {hardOrSoftWoodArray.map((value, index) => (
          <div key={index}>
            <Field
              component={RadioButton}
              name="hardOrSoftWood"
              id={value?.value}
              defaultValue={hardOrSoftWoodArray[0]}
              onSelect={(e) => {
                let tempValue = formikValues?.hardOrSoftWood?.value === e.target?.value ? '' : e.target?.value
                setFieldValue('hardOrSoftWood', { label: tempValue, value: tempValue })
              }}
              label={value?.label}
            />
          </div>
        ))}
      </div>
    );
  };

  const palletTypeSelectionFunction = (selectedOption, material, condition) => {
    setGradeList([]);
    setmoistureList([]);
    setSizeList([]);
    clearFields("moisture", "size", "grade", "length", "width", "height")
    setFieldValue("heatTreated", false);
    setFieldValue("palletType", { label: selectedOption.label, value: selectedOption.value })
    let tempMaterial = material?.value || formikValues.material?.value
    let tempCondition = condition?.value || formikValues.condition?.value
    let tempSpecDetails = palletSpecificationDetails[tempMaterial]?.condition[tempCondition][selectedOption.value]?.palletSpecificDetails;
    let tempMoistureList = tempSpecDetails?.filter((val) => val.moisture && val.moisture !== "").map((val) => val.moisture);
    let tempSizeList = tempSpecDetails?.filter((val) => val.size && val.size !== "").map((val) => val.size);
    if (tempMoistureList && tempMoistureList?.length > 0) {
      tempMoistureList = new Set(tempMoistureList);
      tempMoistureList = Array.from(tempMoistureList);
      tempMoistureList = tempMoistureList.map((data) => ({
        label: data,
        value: data,
      }));
      setmoistureList(tempMoistureList);
    } else if (tempSizeList && tempSizeList?.length > 0) {
      tempSizeList = new Set(tempSizeList);
      tempSizeList = Array.from(tempSizeList);
      tempSizeList = tempSizeList.map((data) => ({ label: data, value: data }));
      setSizeList(tempSizeList);
    } else if (selectedOption?.value === "custom") {
      tempSizeList = [{ label: "Custom", value: "Custom" }];
      setSizeList(tempSizeList);
    }
  }

  const moistureSelectionFunction = (selectedOption, material, condition, palletType) => {
    setGradeList([]);
    setSizeList([]);
    clearFields("size", "grade", "length", "width", "height")
    setFieldValue("isHeatTreated", false);
    setFieldValue("moisture", { label: selectedOption.label, value: selectedOption.value })
    let tempMaterial = material?.value || formikValues.material?.value
    let tempCondition = condition?.value || formikValues.condition?.value
    let tempPalletType = palletType?.value || formikValues.palletType?.value
    let tempSpecDetails = palletSpecificationDetails[tempMaterial]?.condition[tempCondition][tempPalletType]?.palletSpecificDetails;
    let tempSizeList = tempSpecDetails?.filter((val) => val.size && val.size !== "").map((val) => val.size);
    if (tempSizeList && tempSizeList?.length > 0) {
      tempSizeList = new Set(tempSizeList);
      tempSizeList = Array.from(tempSizeList);
      tempSizeList = tempSizeList.map((data) => ({ label: data, value: data }));
      setSizeList(tempSizeList);
    }
  }

  const sizeSelectionFunction = (selectedOption, material, condition, palletType) => {
    setGradeList([]);
    setFieldValue("isHeatTreated", false);
    clearFields("grade", "length", "width", "height")
    setFieldValue("size", { label: selectedOption.label, value: selectedOption.value })
    let tempMaterial = material?.value || formikValues.material?.value
    let tempCondition = condition?.value || formikValues.condition?.value
    let tempPalletType = palletType?.value || formikValues.palletType?.value
    let tempSpecDetails = palletSpecificationDetails[tempMaterial]?.condition[tempCondition][tempPalletType]?.palletSpecificDetails;
    let tempGradeList = tempSpecDetails?.filter((val) => val.grade && val.grade !== "" && val.size === selectedOption.value).map((val) => val.grade);
    if (tempGradeList && tempGradeList?.length > 0) {
      tempGradeList = new Set(tempGradeList);
      tempGradeList = Array.from(tempGradeList);
      tempGradeList = tempGradeList.map((data) => ({
        label: data,
        value: data,
      }));
      setGradeList(tempGradeList);
    }
    setFieldValue("showHeatTreated", true);
  }

  const gradeSelectionFunction = (selectedOption) => {
    setFieldValue("grade", { label: selectedOption.label, value: selectedOption.value })
  }

  const checkDisabled = () => {
    if (Object.keys(errors).length > 0) return true
    if (formikValues?.vendorLocationId === '' || formikValues?.vendorFee <= 0) return true
    if (formikValues?.material === '') return true
    if ((formikValues?.material?.value === 'wood' || formikValues?.material?.value === 'plastic') && formikValues?.condition === '') return true
    if (formikValues?.material?.value === 'wood' && (formikValues?.palletType === '')) return true
    if (formikValues?.material?.value === 'wood' && (sizeList?.length > 0 && formikValues?.size === '')) return true
    if (formikValues?.material?.value === 'wood' && (moistureList?.length > 0 && formikValues?.moisture === '')) return true
    if (formikValues?.material?.value === 'wood' && (gradeList?.length > 0 && formikValues?.grade === '')) return true
    if ((formikValues?.material?.value === 'plastic' || formikValues?.material?.value === 'other' || formikValues?.size?.value === 'Custom') && ((formikValues?.length === "" || formikValues?.length < 1) || (formikValues?.width === "" || formikValues?.width < 1) || (formikValues?.height === "" || formikValues?.height < 1))) return true
    return false
  }

  const clearAllFunction = () => {
    setmoistureList([]);
    setSizeList([]);
    setGradeList([]);
    clearFields('vendorLocationId', 'material', 'condition', 'hardOrSoftWood', 'palletType', 'moisture', 'size', "grade", "length", "width", "height", "customerFee", "vendorFee", "comment")
    setFieldValue("heatTreated", false);
    setFieldValue("showHeatTreated", false);
    setFieldValue('isLtl', false);
    const buyBackFeeStartDate = new Date();
    const startDateValue = moment(buyBackFeeStartDate).format("MM/DD/YYYY");
    setFieldValue('rateStartDate', startDateValue)
    const buyBackFeeEndDate = new Date();
    buyBackFeeEndDate.setFullYear(buyBackFeeEndDate.getFullYear() + 1);
    const endDateValue = moment(buyBackFeeEndDate).format("MM/DD/YYYY");
    setFieldValue('rateExpirationDate', endDateValue)
  }

  const getCustomerFeeFunction = async () => {
    const getCondition = (val) => {
      let conditionValue
      if (val === 'recycled') conditionValue = ['RECYCLED']
      else if (val === 'newCondition') conditionValue = ['NEW']
      else if (val === 'combo') conditionValue = ['COMBO']
      else if (val === 'cores') conditionValue = ['CORES']
      return conditionValue
    }
    let data = {
      customerLocationId: formikValues?.customerLocationId,
      equipment: formikValues?.isLtl ? 'LTL' : 'FTL',
      rateStartDate: moment(formikValues?.rateStartDate).format('MM/DD/YYYY'),
      rateExpirationDate: moment(formikValues?.rateExpirationDate).format('MM/DD/YYYY'),
      palletDetails: {
        material: formikValues?.material?.value?.toUpperCase(),
        condition: getCondition(formikValues?.condition?.value) || [],
        newConditionType: formikValues?.hardOrSoftWood === 'New - HW' ? 'HARDWOOD' : formikValues?.hardOrSoftWood === 'New - SW' ? 'SOFTWOOD' : null,
        palletType: formikValues?.palletType?.value?.toUpperCase() || "CUSTOM",
        moisture: formikValues?.moisture?.value || "",
        size: formikValues?.size?.value,
        grade: formikValues?.grade?.value || "",
        length: formikValues?.length,
        width: formikValues?.width,
        height: formikValues?.height,
        heatTreared: formikValues?.isHeatTreated
      }
    }
    let customerFeeApiResponse = await dispatch(ptPlusVendorPricingGetCustomerFee(data, token));
    if (customerFeeApiResponse?.success) {
      return customerFeeApiResponse.data?.customerFee || 0
    } else {
      setAlertModalContent(customerFeeApiResponse?.data?.error?.message || customerFeeApiResponse?.data?.message || customerFeeApiResponse?.message || 'Something went wrong, please try again in some time.');
      setAlertModal(true);
      return
    }
  }

  const addDataToTable = async () => {
    let getCustomerFee = await getCustomerFeeFunction()
    if (getCustomerFee !== undefined) {
      let tempData = JSON.parse(JSON.stringify(temporaryTableData));
      let tempformikValues = JSON.parse(JSON.stringify(formikValues));
      tempformikValues.customerFee = getCustomerFee || 0
      if (modalMode === 'add') {
        const updatedData = [...tempData, tempformikValues];
        setTemporaryTableData(updatedData);
      } else if (modalMode === 'upd') {
        const updatedData = tempData.map((item, index) => index === updateIndex ? tempformikValues : item);
        setTemporaryTableData(updatedData);
      }
      setModalMode('add')
      setUpdateIndex()

      clearAllFunction()
      let currentFormikValues = tempformikValues
      resetForm()
      setFieldValue('customerLocationId', currentFormikValues?.customerLocationId)
      setFieldValue('customerName', currentFormikValues?.customerName)
      setFieldValue('mainLocationName', currentFormikValues?.mainLocationName)
    }
  }

  const palletDetailsString = (data) => {
    const material = data?.material?.label || "";
    const condition = data?.condition?.label || "";
    const hardOrSoftWood = data?.hardOrSoftWood === 'New - HW' ? "(HW)" :
      data?.hardOrSoftWood === 'New - SW' ? "(SW)" : "";
    const palletType = data?.palletType?.label || "";
    const moisture = data?.moisture?.label || "";
    const size = data?.size?.label !== 'Custom' ? data?.size?.label : "";
    const grade = data?.grade?.label || "";
    const dimensions = data?.length ? `${data?.length}x${data?.width}x${data?.height}` : "";
    const isHeatTreated = data?.isHeatTreated ? "HT" : "";

    if (material !== "Wood") {
      const parts = [material, dimensions].filter(Boolean); // comma between these
      let result = parts.join(', ');
      if (condition) result += ` - ${condition}`; // dash only before condition
      return result;
    } else {
      const parts = [size, dimensions, grade, moisture, isHeatTreated, palletType].filter(Boolean);
      let result = parts.join(', ');
      if (condition) result += ` - ${condition}`;
      if (hardOrSoftWood) result += ` ${hardOrSoftWood}`;
      return result;
    }
  };

  const tableDataEditClick = (data, index) => {
    clearAllFunction()
    setModalMode('upd')
    setUpdateIndex(index)
    setFieldValue("vendorLocationId", data.vendorLocationId);
    setFieldValue("vendorLocationName", data.vendorLocationName);
    setFieldValue("city", data.city);
    setFieldValue("state", data.state);
    setFieldValue("customerFee", data.customerFee);
    setFieldValue("vendorFee", data.vendorFee);
    setFieldValue("isLtl", data.isLtl);
    setFieldValue("rateStartDate", data.rateStartDate);
    setFieldValue("rateExpirationDate", data.rateExpirationDate);
    setFieldValue("comment", data.comment);

    //pallet details
    setFieldValue("material", data.material);
    setFieldValue("condition", data.condition);
    setFieldValue("hardOrSoftWood", data.hardOrSoftWood);
    setFieldValue("palletType", data.palletType);
    if (data.material?.value === 'wood') palletTypeSelectionFunction(data?.palletType, data.material, data?.condition)
    setFieldValue("moisture", data.moisture);
    if (data.material?.value === 'wood' && data?.moisture !== '') moistureSelectionFunction(data?.moisture, data.material, data?.condition, data?.palletType)
    setFieldValue("size", data.size);
    if (data.material?.value === 'wood') sizeSelectionFunction(data?.size, data.material, data?.condition, data?.palletType)
    setFieldValue("grade", data.grade);
    setFieldValue("length", data.length);
    setFieldValue("width", data.width);
    setFieldValue("height", data.height);
    setFieldValue("showHeatTreated", data.showHeatTreated);
    setFieldValue("isHeatTreated", data.isHeatTreated);
  }

  const submitAddPricingForm = async () => {
    const getCondition = (val) => {
      let conditionValue
      if (val === 'recycled') conditionValue = ['RECYCLED']
      else if (val === 'newCondition') conditionValue = ['NEW']
      else if (val === 'combo') conditionValue = ['COMBO']
      else if (val === 'cores') conditionValue = ['CORES']
      return conditionValue
    }
    let vendorPricingData = temporaryTableData?.map(data => {
      return (
        {
          vendorLocationId: data?.vendorLocationId?.value,
          vendorLocationName: data?.vendorLocationName,
          city: data?.city,
          state: data?.state,
          feeDetailsReq: [
            {
              palletDetails: {
                material: data?.material?.value?.toUpperCase(),
                condition: getCondition(data?.condition?.value) || [],
                newConditionType: data?.hardOrSoftWood === 'New - HW' ? 'HARDWOOD' : data?.hardOrSoftWood === 'New - SW' ? 'SOFTWOOD' : null,
                palletType: data?.palletType?.value?.toUpperCase() || "CUSTOM",
                moisture: data?.moisture?.value || "",
                size: data?.size?.value,
                grade: data?.grade?.value || "",
                length: data?.length,
                width: data?.width,
                height: data?.height,
                heatTreared: data?.isHeatTreated
              },
              equipment: data?.isLtl ? 'LTL' : 'FTL',
              customerFee: data?.customerFee,
              vendorFee: data?.vendorFee,
              rateStartDate: moment(data?.rateStartDate).format('YYYY-MM-DD'),
              rateExpirationDate: moment(data?.rateExpirationDate).format('YYYY-MM-DD'),
              comment: data?.comment
            }
          ]
        }
      )
    })
    let data
    if (pageType === 'addMoreVendor') {
      data = {
        id: addMoreSelectedItem?.id,
        update: false,
        vendorPricing: vendorPricingData,
        updateReq: null
      }
    } else {
      data = {
        customerLocationId: formikValues?.customerLocationId,
        mainLocationName: formikValues?.mainLocationName,
        mainLocationId: formikValues?.customerName,
        vendorPricing: vendorPricingData
      }
    }
    let response
    if (pageType === 'addMoreVendor') {
      response = await dispatch(ptPlusVendorPricingAddMoreVendorData(data, token));
    } else {
      response = await dispatch(ptPlusVendorPricingAddData(data, token));
    }
    if (response?.success) {
      setAlertModalType('addSuccess')
      setAlertModalContent(response?.data?.msg)
      setAlertModal(true);
    } else {
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setAlertModal(true);
      }
    }
  }

  return (
    <>
      <Modal isOpen={true} centered={true} size={'lg'} className="vendor-pricing-modal-style">
        <VendorPricingAddModal>
          <ModalBody>
            {(loaderVisible || loader) && <Spinner />}
            <div>
              <div className="main-header">
                <h4>Add Vendor Pricing</h4>
                <img src={CloseIcon} alt="close-icon" onClick={() => {
                  clearAllFunction()
                  let currentFormikValues = formikValues
                  resetForm()
                  setFieldValue('customerLocationId', currentFormikValues?.customerLocationId)
                  setFieldValue('customerName', currentFormikValues?.customerName)
                  setFieldValue('mainLocationName', currentFormikValues?.mainLocationName)
                  closeModal()
                }} />
              </div>
              <div className="new-data-add-section-style">
                <div className="outer-wrapper">
                  <div className="top-row-style">
                    <Select
                      id="vendorLocationId"
                      name='vendorLocationId'
                      value={formikValues.vendorLocationId || null}
                      onChange={(selectedOption) => {
                        setFieldValue("vendorLocationId", { label: selectedOption.label, value: selectedOption.value });
                        setFieldValue("vendorLocationName", selectedOption.vendorLocationName);
                        setFieldValue("city", selectedOption.city);
                        setFieldValue("state", selectedOption.state);
                      }}
                      options={vendorLocationList}
                      placeholder="Vendors*"
                    />
                    <Select
                      id="material"
                      name='material'
                      value={formikValues.material || null}
                      onChange={(selectedOption) => {
                        setFieldValue("material", { label: selectedOption.label, value: selectedOption.value });
                        setmoistureList([]);
                        setSizeList([]);
                        setGradeList([]);
                        clearFields('condition', 'hardOrSoftWood', 'palletType', 'moisture', 'size', "grade", "length", "width", "height")
                        setFieldValue("heatTreated", false);
                        setFieldValue("showHeatTreated", false);
                      }}
                      options={materialList}
                      placeholder="Material*"
                    />
                    {(formikValues.material?.value === 'wood' || formikValues.material?.value === 'plastic') &&
                      <Select
                        id="condition"
                        name='condition'
                        value={formikValues.condition || null}
                        onChange={(selectedOption) => {
                          setFieldValue("condition", { label: selectedOption.label, value: selectedOption.value });
                          setmoistureList([]);
                          setSizeList([]);
                          setGradeList([]);
                          clearFields('hardOrSoftWood', 'palletType', 'moisture', 'size', "grade", "length", "width", "height")
                          setFieldValue("heatTreated", false);
                          setFieldValue("showHeatTreated", false);
                        }}
                        options={formikValues.material?.value === 'wood' ? woodConditions : plasticConditions}
                        placeholder="Condition*"
                      />
                    }
                    {(formikValues.material?.value === 'wood' && formikValues.condition?.value === 'newCondition') && hardOrSoftWoodDiv()}
                  </div>
                  <div className="pallet-details-row-style">
                    {(formikValues?.material?.value !== "plastic" && formikValues?.material?.value !== "other") &&
                      <Select
                        id="palletType"
                        name='palletType'
                        value={formikValues.palletType || null}
                        onChange={(selectedOption) => palletTypeSelectionFunction(selectedOption)}
                        options={(formikValues.material?.value === 'wood' && (formikValues.condition?.value === 'newCondition' || formikValues.condition?.value === 'recycled')) ? newOrRecycledPalletList : (formikValues.material?.value === 'wood' && formikValues.condition?.value === 'combo') ? comboPalletList : []}
                        placeholder="Pallet Type*"
                      />
                    }
                    {moistureList?.length > 0 &&
                      <Select
                        id="moisture"
                        name='moisture'
                        value={formikValues.moisture || null}
                        onChange={(selectedOption) => moistureSelectionFunction(selectedOption)}
                        options={moistureList}
                        placeholder="Moisture*"
                      />
                    }
                    {(formikValues?.material?.value !== "plastic" && formikValues?.material?.value !== "other") &&
                      <Select
                        id="size"
                        name='size'
                        value={formikValues.size || null}
                        onChange={(selectedOption) => sizeSelectionFunction(selectedOption)}
                        options={sizeList}
                        placeholder="Size*"
                      />
                    }
                    {gradeList.length > 0 &&
                      <Select
                        id="grade"
                        name='grade'
                        value={formikValues.grade || null}
                        onChange={(selectedOption) => gradeSelectionFunction(selectedOption)}
                        options={gradeList}
                        placeholder="Grade*"
                      />
                    }
                    {(formikValues?.material?.value === "plastic" || formikValues?.material?.value === "other" || formikValues?.size?.value === "Custom") && (
                      <div className="custom-size-styles">
                        <NumberInput
                          name="length"
                          placeholder={'Length*'}
                          showErrorMessages={true}
                          maxLength={5}
                          onChangeHandler={(value) => { }}
                        />
                        <NumberInput
                          name="width"
                          placeholder={'Width*'}
                          showErrorMessages={true}
                          maxLength={5}
                          onChangeHandler={(value) => { }}
                        />
                        <NumberInput
                          name="height"
                          placeholder={'Height*'}
                          showErrorMessages={true}
                          maxLength={5}
                          onChangeHandler={(value) => { }}
                        />
                      </div>
                    )}
                    {formikValues?.showHeatTreated && (
                      <CheckboxInput
                        name="isHeatTreated"
                        label="Heat Treated"
                        checked={formikValues?.isHeatTreated}
                        handleSelect={(val, label, flag) => {
                          setFieldValue('isHeatTreated', flag)
                        }}
                      />
                    )}
                    <CheckboxInput
                      name="isLtl"
                      label="LTL"
                      checked={formikValues?.isLtl}
                      handleSelect={(val, label, flag) => {
                        setFieldValue('isLtl', flag)
                      }}
                    />
                  </div>
                  <div className="vendor-pricing-style">
                    {/* <NumberInput
                      name='customerFee'
                      showErrorMessages={true}
                      decimalScale={2}
                      placeholder="Customer Price*"
                      maxLength={8}
                      onChangeHandler={(val) => {
                        setFieldValue("customerFee", val);
                      }}
                    /> */}
                    <NumberInput
                      name='vendorFee'
                      showErrorMessages={true}
                      decimalScale={2}
                      placeholder="Vendor Price*"
                      maxLength={8}
                      onChangeHandler={(val) => {
                        setFieldValue("vendorFee", val);
                      }}
                    />
                    <div>
                      <DatePicker
                        name='rateStartDate'
                        maxDOBirth={formikValues.rateExpirationDate}
                        value={formikValues.rateStartDate}
                        type="buyBackFeeForm"
                        callBackFun={(date, value) => {
                          setFieldValue("rateStartDate", moment(date).format("MM/DD/YYYY"));
                        }}
                      />
                      {errors.rateStartDate && <p className="error-message">{errors.rateStartDate}</p>}
                    </div>
                    <p>To</p>
                    <div>
                      <DatePicker
                        name='rateExpirationDate'
                        minDOBirth={formikValues.rateStartDate}
                        value={formikValues.rateExpirationDate}
                        type="buyBackFeeForm"
                        callBackFun={(date, value) => {
                          setFieldValue("rateExpirationDate", moment(date).format("MM/DD/YYYY"));
                        }}
                      />
                      {errors.rateExpirationDate && <p className="error-message">{errors.rateExpirationDate}</p>}
                    </div>
                    <div className="text-area-style">
                      <Textarea
                        name='comment'
                        placeholder='Comment'
                        showErrorMessages={true}
                        rows={1}
                        onChange={(val) => {
                          setFieldValue("comment", val);
                        }}
                      />
                    </div>
                  </div>
                  <div className="add-button-style">
                    <button
                      style={{ opacity: checkDisabled() ? 0.5 : 1 }}
                      disabled={checkDisabled()}
                      onClick={addDataToTable}
                    >{modalMode === 'add' ? 'Add' : 'Update'}</button>
                  </div>
                </div>
                <div className="table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        {vendorPricingAddTableHeader?.map((data, index) => {
                          return (
                            <th key={index}>{data}</th>
                          )
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {temporaryTableData?.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td>{data?.vendorLocationId?.label}</td>
                            <td>{palletDetailsString(data)}</td>
                            {/* <td>$ {parseFloat(data?.customerFee)?.toFixed(2)}</td> */}
                            <td>$ {parseFloat(data?.vendorFee)?.toFixed(2)}</td>
                            <td>{data?.isLtl ? 'LTL' : 'FTL'}</td>
                            <td>{data?.rateStartDate}</td>
                            <td>{data?.rateExpirationDate}</td>
                            <td class="actions">
                              <span class="icon" onClick={() => tableDataEditClick(data, index)}><EditIcon /></span>
                              <span class="icon" style={{ opacity: updateIndex !== index ? 1 : 0.5 }} onClick={() => {
                                if (updateIndex !== index) {
                                  let tempData = JSON.parse(JSON.stringify(temporaryTableData));
                                  tempData.splice(index, 1)
                                  if (index < updateIndex) setUpdateIndex(updateIndex - 1)
                                  setTemporaryTableData(tempData);
                                }
                              }}><DeleteIcon /></span>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  <div className="submit-button-style">
                    <button
                      style={{ opacity: (temporaryTableData?.length === 0) ? 0.5 : 1 }}
                      disabled={temporaryTableData?.length === 0}
                      onClick={submitAddPricingForm}
                    >Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </VendorPricingAddModal>
      </Modal>

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType='success'
        callBackAlert={() => {
          if (alertModalType === 'addSuccess') {
            clearAllFunction()
            resetForm()
            closeModal('addSuccess')
          }
        }}
      />
      <YesNoModal
        isOpen={yesNomodal}
        toggle={() => setYesNoModal(!yesNomodal)}
        title=""
        content={yesNoModalContent}
        link={'/'}
        type={''}
        onClickHander={(val) => {
          setYesNoModal(!yesNomodal)
        }}
      />
    </>
  );
}

export default VendorPricingModal;
